import { render } from "./purchase-receipt.vue?vue&type=template&id=546048d9&scoped=true"
import script from "./purchase-receipt.vue?vue&type=script&lang=js"
export * from "./purchase-receipt.vue?vue&type=script&lang=js"

import "./purchase-receipt.vue?vue&type=style&index=0&id=546048d9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546048d9"]])

export default __exports__